import { render, staticRenderFns } from "./departmentDetail.vue?vue&type=template&id=27432e28&scoped=true"
import script from "./departmentDetail.vue?vue&type=script&lang=js"
export * from "./departmentDetail.vue?vue&type=script&lang=js"
import style0 from "./departmentDetail.vue?vue&type=style&index=0&id=27432e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27432e28",
  null
  
)

export default component.exports